import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
const { proxy } = require('../../ip_api.config')

class Flim_EditBomVersion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                this.push_arrItemSave()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    push_arrItemSave = () => {
        // console.log('id', this.state.id)
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let url = proxy.server + '/flim/get_bomversion'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        db_name: val.db_name,
                        user: val.BOMVersion_ApproverPersonnelNumber,
                        bom_no: val.BOM_BOMId,
                        bom_description: val.BOM_Name,
                        item_group: val.BOM_ItemGroupId,
                        item_no: val.ItemId,
                        item_description: val.Name,
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp }, () => { this.getItem_Preview() })
            })
    }

    getItem_Preview = async () => {
        let arr = []

        arr = await Promise.all(this.state.arr_save.map(async function (val, i) {
            console.log("val", val)
            return <tr>
                <td><bs4.Col sm='12'>
                    <bs4.Input type="select" name="db_name" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                        <option value={val.db_name}>{val.db_name}</option>
                        <option value="DPL">DPL</option>
                        <option value="DFIX">DFIX</option>
                        <option value="DPT">DPT</option>
                    </bs4.Input>
                </bs4.Col></td>
                <td>{val.user}</td>
                <td>
                    <bs4.Col sm='12'>
                        <bs4.Input type="text" name="bom_no" onBlur={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_no} />
                    </bs4.Col>
                </td>
                <td>
                    <bs4.Col sm='12'>
                        <bs4.Input type="textarea" name="bom_description" onBlur={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.bom_description} />
                    </bs4.Col>
                </td>
                <td>{this.state.arr_save[i].item_group}</td>
                <td>
                    <bs4.Input type="text" name="item_no" onBlur={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.item_no} />
                </td>
                <td>
                    <bs4.Input type="textarea" name="item_description" onBlur={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.item_description} />
                </td>
            </tr>
        }, this))
        this.setState({ previewItem: arr, isLoading: false })
    }

    get_dataStandrad = async (itemG1) => new Promise((resolve, reject) => {
        let url = proxy.server + '/flim/get_dataStandrad'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                itemG1: itemG1,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("get_dataStandrad", responseJson.result[0])
                if (responseJson.result.lenght !== []) {
                    resolve(responseJson.result[0])
                } else {
                    resolve(0)
                }
            })
    })

    handleChangeItem = async (index, name, value) => {
        if (name === 'db_name') {
            this.state.arr_save[index].db_name = value
        } else if (name === 'bom_no') {
            this.state.arr_save[index].bom_no = value
        } else if (name === 'bom_description') {
            this.state.arr_save[index].bom_description = value
        } else if (name === 'item_no') {
            this.state.arr_save[index].item_no = value

            let dataStandrad = await this.get_dataStandrad(value.substr(0, 3))
            this.state.arr_save[index].item_group = dataStandrad === undefined || dataStandrad.ItemGroupId === null ? '' : dataStandrad.ItemGroupId
        } else if (name === 'item_description') {
            this.state.arr_save[index].item_description = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.getItem_Preview()

        })
    }

    update_item = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/update_bomversion'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: this.state.id,
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false })
                        this.props.history.push({
                            pathname: '/Flim/PreviewBomVer'
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_EditBomVersion'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >EDIT BOM VERSION</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_item()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th>ฐานข้อมูล</th>
                            <th>User</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Bom Code</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Bom Name</th>
                            <th>ItemGroupId</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Item Code</th>
                            <th style={{ backgroundColor: '#61ba52', color: '#000' }}>Item Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Flim_EditBomVersion